import React, { useState, useEffect } from "react";
import "../../index.css";

const initialData = [
  {
    id: 1,
    studentName: "Rahul Kumar",
    regdNo: "25001",
    hostelBlock: "Block A",
    roomNo: "101",
    hostelFee: 2500,
    status: "Active"
  }
];

const StudentHostel = () => {

  const [list, setList] = useState([]);
  const [selected, setSelected] = useState(null);
  const [search, setSearch] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [formData, setFormData] = useState({
    id: "",
    studentName: "",
    regdNo: "",
    hostelBlock: "",
    roomNo: "",
    hostelFee: "",
    status: "Active"
  });

  const [errors, setErrors] = useState({});

  // LOAD DATA
  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("studentHostel")) || [];

    if (saved.length === 0) {
      localStorage.setItem("studentHostel", JSON.stringify(initialData));
      setList(initialData);
    } else {
      setList(saved);
    }
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      const saved = JSON.parse(localStorage.getItem("studentHostel")) || [];
      setList(saved);
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  // SEARCH
  const filtered = list.filter((item) =>
    (item.studentName || "").toLowerCase().includes(search.toLowerCase()) ||
    (item.hostelBlock || "").toLowerCase().includes(search.toLowerCase()) ||
    (item.roomNo || "").toLowerCase().includes(search.toLowerCase())
  );

  // VALIDATION
  const validate = () => {
    let err = {};

    if (!formData.studentName.trim()) err.studentName = "Required";
    if (!formData.regdNo) err.regdNo = "Required";
    if (!formData.hostelBlock.trim()) err.hostelBlock = "Required";
    if (!formData.roomNo.trim()) err.roomNo = "Required";
    if (!formData.hostelFee) err.hostelFee = "Required";

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  // ADD
  const openAdd = () => {
    setIsEdit(false);
    setErrors({});
    setFormData({
      id: "",
      studentName: "",
      regdNo: "",
      hostelBlock: "",
      roomNo: "",
      hostelFee: "",
      status: "Active"
    });
    setShowModal(true);
  };

  // EDIT
  const openEdit = () => {
    if (!selected) return alert("Select row first");

    setIsEdit(true);
    setErrors({});
    setFormData(selected);
    setShowModal(true);
  };

  // DELETE
  const handleDelete = () => {
    if (!selected) return alert("Select row first");

    const updated = list.filter((l) => l.id !== selected.id);
    setList(updated);
    localStorage.setItem("studentHostel", JSON.stringify(updated));
    setSelected(null);
  };

  // SAVE
  const handleSave = () => {
    if (!validate()) return;

    let updatedList = [];

    if (isEdit) {
      updatedList = list.map((l) =>
        l.id === formData.id ? formData : l
      );
    } else {
      const newItem = {
        ...formData,
        id: Date.now()
      };
      updatedList = [newItem, ...list];
    }

    setList(updatedList);
    localStorage.setItem("studentHostel", JSON.stringify(updatedList));
    window.dispatchEvent(new Event("storage"));

    setShowModal(false);
    setSelected(null);
  };

  return (
    <>
      <style>{`
        .page { background:#f5f7fb; padding:20px; }
        .card { background:#fff; padding:15px; border-radius:8px; }

        .header {
          display:flex;
          justify-content:space-between;
          margin-bottom:10px;
        }

        .controls {
          display:flex;
          gap:10px;
          margin-bottom:10px;
          flex-wrap:wrap;
        }

        .search-box {
          padding:8px;
          border:1px solid #ccc;
          border-radius:4px;
        }

        .btn {
          padding:7px 12px;
          border:none;
          border-radius:4px;
          cursor:pointer;
        }

        .btn-dark { background:#2c3e50; color:#fff; }
        .btn-blue { background:#3498db; color:#fff; }
        .btn-red { background:#e74c3c; color:#fff; }

        table {
          width:100%;
          border-collapse:collapse;
        }

        th, td {
          padding:10px;
          border-bottom:1px solid #eee;
        }

        tr:hover { background:#f4f6f9; cursor:pointer; }
        .active-row { background:#eef3ff; }

        .modal {
          position:fixed;
          top:0; left:0;
          width:100%; height:100%;
          background:rgba(0,0,0,0.5);
          display:flex;
          justify-content:center;
          align-items:center;
        }

        .modal-content {
          background:white;
          padding:30px;
          border-radius:8px;
          width:400px;
        }

        .error {
          border:1px solid red;
        }

        .error-text {
          color:red;
          font-size:12px;
        }
      `}</style>

      <div className="page">
        <div className="card">

          <div className="header">
            <h3>Student Hostel</h3>
            <div>{list.length} Records</div>
          </div>

          <div className="controls">
            <input
              className="search-box"
              placeholder="Search student / block / room..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <button className="btn btn-dark" onClick={openAdd}>
              + Add
            </button>

            <button className="btn btn-blue" onClick={openEdit}>
              Update
            </button>

            <button className="btn btn-red" onClick={handleDelete}>
              Delete
            </button>
          </div>

          <table>
            <thead>
              <tr>
                <th></th>
                <th>S.ID</th>
                <th>Student Name</th>
                <th>Registration No</th>
                <th>Hostel Block</th>
                <th>Room No</th>
                <th>Hostel Fee</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {filtered.map((item, index) => (
                <tr
                  key={item.id}
                  className={selected?.id === item.id ? "active-row" : ""}
                  onClick={() =>
                    setSelected(selected?.id === item.id ? null : item)
                  }
                >
                  <td>
                    <input
                      type="checkbox"
                      checked={selected?.id === item.id}
                      onChange={() =>
                        setSelected(selected?.id === item.id ? null : item)
                      }
                      onClick={(e) => e.stopPropagation()}
                    />
                  </td>

                  <td>{index + 1}</td>
                  <td>{item.studentName}</td>
                  <td>{item.regdNo}</td>
                  <td>{item.hostelBlock}</td>
                  <td>{item.roomNo}</td>
                  <td>₹ {item.hostelFee}</td>
                  <td>{item.status}</td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>
      </div>

      {/* MODAL */}
      {showModal && (
        <div className="modal">
          <div className="modal-content">

            <h3>{isEdit ? "Update Hostel" : "Add Hostel"}</h3>

            <input
              placeholder="Student Name"
              value={formData.studentName}
              className={errors.studentName && "error"}
              onChange={(e) =>
                setFormData({ ...formData, studentName: e.target.value })
              }
            />
            <div className="error-text">{errors.studentName}</div>

            <input
              placeholder="Registration No"
              value={formData.regdNo}
              className={errors.regdNo && "error"}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  regdNo: e.target.value.replace(/\D/g, "")
                })
              }
            />
            <div className="error-text">{errors.regdNo}</div>

            <input
              placeholder="Hostel Block"
              value={formData.hostelBlock}
              className={errors.hostelBlock && "error"}
              onChange={(e) =>
                setFormData({ ...formData, hostelBlock: e.target.value })
              }
            />
            <div className="error-text">{errors.hostelBlock}</div>

            <input
              placeholder="Room No"
              value={formData.roomNo}
              className={errors.roomNo && "error"}
              onChange={(e) =>
                setFormData({ ...formData, roomNo: e.target.value })
              }
            />
            <div className="error-text">{errors.roomNo}</div>

            <input
              type="number"
              placeholder="Hostel Fee"
              value={formData.hostelFee}
              className={errors.hostelFee && "error"}
              onChange={(e) =>
                setFormData({ ...formData, hostelFee: e.target.value })
              }
            />
            <div className="error-text">{errors.hostelFee}</div>

            <select
              value={formData.status}
              onChange={(e) =>
                setFormData({ ...formData, status: e.target.value })
              }
            >
              <option>Active</option>
              <option>Inactive</option>
            </select>

            <div style={{ display: "flex", gap: "10px" }}>
              <button className="btn btn-blue" onClick={handleSave}>
                Save
              </button>

              <button
                className="btn btn-red"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
};

export default StudentHostel;